/**
 * @module https://github.com/wwayne/react-tooltip
 */

import {cloneElement, ReactElement, useId} from 'react';
import {ITooltip, Tooltip as ReactTooltip} from 'react-tooltip';
import {createGlobalStyle} from 'styled-components';
import {palette} from '@/styles';

interface IProps extends ITooltip {
  children: ReactElement<any>;
}

const options: ITooltip = {
  border: `solid 1px ${palette.gray900}`,
  noArrow: true,
  opacity: 1,
  place: 'bottom-start',
  offset: 0,
};

const CLASSNAME = 'rt-small-action-tooltip-class';

export const ActionGuideTooltip = ({
  children: Component,
  content,
  className,
  ...props
}: IProps) => {
  const id = useId();
  const tooltipClassName = ((className || '') + ' ' + CLASSNAME).trim();

  return (
    <>
      <GlobalTooltipStyle />
      {cloneElement(Component, {
        'data-tooltip-id': id,
        'data-tooltip-content': content,
      })}
      <ReactTooltip
        id={id}
        {...options}
        {...props}
        className={tooltipClassName}
      />
    </>
  );
};

const GlobalTooltipStyle = createGlobalStyle`
  .${CLASSNAME} {
    box-shadow: 0px 4px 10px 0px #00000026 !important;
    padding: 2px 6px !important;
    background-color: ${palette.black} !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    line-height: 16px !important;
    color: ${palette.white} !important;
    pointer-events: auto !important;
    max-width: 320px !important;
        border-radius: 6px !important;
`;
